module.exports = __webpack_public_path__ + "static/media/alert-circle.44c1f838.svg";